import { NextPage } from 'next';
import { GetStaticProps } from 'next';
import New from '@/components/screens/new/New';
import { BOOKS_FOR_PAGE, API_URL, REVALIDATE_TIME } from '@/helpers/variables';
import { IBooksPage } from '@/interfaces/booksPage.interface';

const NewPage: NextPage<IBooksPage> = ({ books }) => {
  return <New books={books} />;
};

export const getStaticProps: GetStaticProps = async () => {
  const res = await fetch(`${API_URL}satellite/books/news?page=1&page_size=${BOOKS_FOR_PAGE}`);
  const books = await res.json();

  return {
    props: { books },
    revalidate: REVALIDATE_TIME,
  };
};

export default NewPage;
